import React, { useEffect, useState } from 'react';
import { formActions, rootActions, useAppDispatch, useAppSelector } from '../../data/store';
import IconPreview from '../IconPreview';
import { getSaveForLaterIcons } from '../../domain/icons-provider';
import { ISaveForLaterItem } from '../../interfaces';
import CloseIcon from '../icons/CloseIcon';
import QuestionIcon from '../icons/QuestionIcon';
import SavedIconsPopup from './SavedIconsPopup';

const SavedIcons = () => {

    const dispatch = useAppDispatch();
    const [popupShown, setPopupShown] = useState(false);

    const iconsData = useAppSelector(store => store.root.iconsData);
    const savedForLaterIcons = useAppSelector(store => store.root.savedForLaterIcons);

    const [data, setData] = useState<ISaveForLaterItem[]>([]);

    useEffect(() => {
        (async () => {
            const data = await getSaveForLaterIcons(iconsData, savedForLaterIcons);
            setData(data);
        })();
    });

    const showPopup = () => {
        setPopupShown(true);
    };

    const deleteSaveForLater = (id: string) => {
        const filtered = [...savedForLaterIcons].filter(item => item.id !== id);
        dispatch(
            rootActions.saveForLaterIcons(filtered)
        );
    };

    const select = (item: ISaveForLaterItem) => {
        dispatch(
            formActions.main({
                strokeWidth: item.saveForLaterItem.strokeWidth,
                strokeColor: item.saveForLaterItem.strokeColor,
                hasStroke: item.saveForLaterItem.hasStroke,

                fillColor: item.saveForLaterItem.fillColor,
                hasFill: item.saveForLaterItem.hasFill,

                backgroundColor: item.saveForLaterItem.backgroundColor,
                backgroundType: item.saveForLaterItem.backgroundType,

                rotation: item.saveForLaterItem.rotation,
                scale: item.saveForLaterItem.scale,

                sharpness: item.saveForLaterItem.sharpness,
                smoothness: item.saveForLaterItem.smoothness,
            })
        );

        dispatch(
            rootActions.main({
                randomIcon: item.icon,
            })
        );

        // scroll back to the preview
        const $preview = document.getElementById('preview');
        if(!$preview) return;

        $preview.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest'
        });
    };

    const clearAllIconsHandler = () => {
        if(window.confirm('Are you sure you want to delete all saved icons?')){
            dispatch(
                rootActions.saveForLaterIcons([])
            );
        }
    };

    return (
        <div id="saved-for-later" className="my-10">
            <h3 className="text-center mt-20 mb-10 text-2xl md:text-4xl font-open-sans">
                <span className="mr-4">Saved for Later Icons</span>
                <button
                    type="button"
                    className="bg-gray-200 text-gray-700 rounded-full cursor-pointer mr-4"
                    onClick={ showPopup }>
                    <QuestionIcon />
                </button>
                <button
                    type="button"
                    title="Clear all saved icons"
                    className="bg-gray-200 text-gray-700 rounded-full cursor-pointer"
                    onClick={ clearAllIconsHandler }>
                    <CloseIcon width="20px" height="20px" />
                </button>
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-8 md:my-8 shadow-lg shadow-slate-200 rounded p-4 md:p-10 items-center justify-center ">
                {
                    data.map((item, index) => {

                        return (
                            <div
                                key={ `saved-for-later-item-${ index }` }
                                className="flex flex-col items-center justify-center border rounded bg-gray-100 px-4 py-3">

                                <button
                                    type="button"
                                    className="self-end"
                                    onClick={ () => {
                                        deleteSaveForLater(item.saveForLaterItem.id);
                                    }}>
                                    <CloseIcon />
                                </button>

                                <button
                                    type="button"
                                    className="flex justify-center w-28 h-28 max-w-full mx-auto"
                                    title="Select Icon"
                                    onClick={ () => {
                                        select(item);
                                    }}>

                                    <IconPreview
                                        iconSvg={ item.icon.svg }
                                        size={ 96 }

                                        strokeWidth={ item.saveForLaterItem.strokeWidth }
                                        strokeColor={ item.saveForLaterItem.strokeColor }
                                        hasStroke={ item.saveForLaterItem.hasStroke }

                                        fillColor={ item.saveForLaterItem.fillColor }
                                        hasFill={ item.saveForLaterItem.hasFill }

                                        backgroundColor={ item.saveForLaterItem.backgroundColor }
                                        backgroundType={ item.saveForLaterItem.backgroundType }

                                        rotation={ item.saveForLaterItem.rotation }
                                        scale={ item.saveForLaterItem.scale }

                                        sharpness={ item.saveForLaterItem.sharpness }
                                        smoothness={ item.saveForLaterItem.smoothness }
                                    />

                                </button>
                            </div>
                        )
                    })
                }
            </div>

            { popupShown && <SavedIconsPopup setPopupShown={ setPopupShown } /> }
        </div>
    )
};

export default SavedIcons;